import call from "../../service/http";
import licenseConstants from "./LicenseConstants";
import { helper } from "../../utils";

export default {
  namespaced: true,
  state: {
    licenseApplications: [],
    licenseApplicationReport: [],
    profile: [],
    application: {
      description: "",
      profileID: "",
      applicationDate: "",
      amount: 0,
      memberCategory: "",
      startDate: "",
      countryCode: "",
      county: "",
      city: "",
      postalCode: "",
      physicalLocation: "",
      phoneNo: "",
      email: "",
      practiceName: "",
      practitionerSurname: "",
      practitionerOtherNames: "",
      practitionerPhone: "",
      practitionerEmail: "",
      practitionerAddress: "",
    },
    certificateOfGoodStanding: "",
    checklist: [],
    licenses: [],
    LicenseCertificate: "",
    licenseApplication: "",
    proforma: "",
    memberInformation: {},
    membershipComments: [],
  },
  mutations: {
    MUTATE: (state, payload) => {
      state[payload.state] = payload.data;
    },

    SET_APPLICATION: (state, payload) => {
      state.application = payload;
    },
  },
  getters: {
    licenseGetters: (state) => (val) => state[val],
  },
  actions: {
    setLoading({ commit }, payload) {
      commit("SET_LOADING", payload, { root: true });
    },
    getLicenseApplications: ({ commit }) => {
      commit("SET_LOADING", true, { root: true });
      call("get", licenseConstants.LICENSE_APPLICATIONS)
        .then((res) => {
          commit("MUTATE", {
            state: "licenseApplications",
            data: res.data.data,
          });
        })
        .catch((error) => {
          commit("SET_ALERT", {
            status: "error",
            message: error.response.data.message,
          });
        })
        .finally(() => {
          commit("SET_LOADING", false, { root: true });
        });
    },

    getLicenseProfile: ({ commit }) => {
      commit("SET_LOADING", true, { root: true });
      call("get", licenseConstants.PROFILE)
        .then((res) => {
          commit("MUTATE", {
            state: "profile",
            data: res.data.data[0],
          });
          commit("SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: error.response.data.message,
          });
        });
    },

    submitApplication: ({ commit }, data) => {
      commit("SET_LOADING", true, { root: true });

      let payload = {};
      if (data?.application) {
        payload = data.application;
      } else {
        payload = data;
      }

      call("post", licenseConstants.LICENSE(null), payload)
        .then((res) => {
          commit("SET_APPLICATION", res.data.data);
          commit("SET_LOADING", false, { root: true });

          if (data?.event) {
            Event.$emit(data.event, { tab: data.tab, license: res.data.data });
          } else {
            Event.$emit(
              "ApiSuccess",
              "License application created successfully"
            );
            setTimeout(() => {
              Event.$emit("License-saved", res.data.data);
            }, 500);
          }
        })
        .catch((error) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: error.response.data.message,
          });
          Event.$emit(
            "ApiError",
            error.response.data.message ??
              "Error submitting license application"
          );
        });
    },
    updateApplication: ({ commit }, data) => {
      commit("SET_LOADING", true, { root: true });

      let payload = {};
      if (data?.application) {
        payload = data.application;
      } else {
        payload = data;
      }

      call("patch", licenseConstants.UPDATE_APPLICATION, payload)
        .then((res) => {
          commit("SET_APPLICATION", res.data.data);
          commit("SET_LOADING", false, { root: true });

          if (data?.event) {
            Event.$emit(data.event, { tab: data.tab, license: res.data.data });
          } else {
            Event.$emit(
              "ApiSuccess",
              "License application created successfully"
            );
            setTimeout(() => {
              Event.$emit("License-saved", res.data.data);
            }, 500);
          }
        })
        .catch((error) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: error.response.data.message,
          });
        });
    },

    getChecklists: ({ commit }, data) => {
      commit("SET_LOADING", true, { root: true });
      call("get", licenseConstants.CHECKLIST(data))
        .then((res) => {
          commit("MUTATE", { state: "checklist", data: res.data.data });
          commit("SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: error.response.data.message,
          });
        });
    },

    certificateOfGoodStanding({ commit }, data) {
      commit("SET_LOADING", true, { root: true });
      call("get", licenseConstants.CERTIFICATE_OF_GOOD_STANDING(data))
        .then((res) => {
          commit("MUTATE", {
            state: "certificateOfGoodStanding",
            data: res.data.data,
          });
          commit("SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: error.response.data.message,
          });
        });
    },

    updateLicence: ({ commit, dispatch }, data) => {
      commit("SET_LOADING", true);
      call(
        "post",
        licenseConstants.LICENSE_UPDATE,
        helper.prepareFormData(data)
      )
        .then((res) => {
          commit("MUTATE", { state: "licenses", data: res.data.data });
          commit("SET_LOADING", false, { root: true });
          dispatch("getApplication", data.licenseApplicationNo);
          commit("SET_ALERT", {
            status: "success",
            message: res.response.data.message,
          });
        })
        .catch((error) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: error.response.data.message,
          });
        });
    },

    getApplication: ({ commit }, no) => {
      commit("SET_LOADING", true);
      call("get", licenseConstants.APPLICATION(no))
        .then((res) => {
          commit("MUTATE", {
            state: "application",
            data: res.data.data[0],
          });
          commit("SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: error.response.data.message,
          });
        });
    },

    getApplicationReport: ({ commit }, no) => {
      commit("SET_LOADING", true);
      call("get", licenseConstants.APPLICATION_REPORT(no))
        .then((res) => {
          commit("MUTATE", {
            state: "licenseApplicationReport",
            data: res.data.data[0],
          });
          commit("SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: error.response.data.message,
          });
        });
    },

    getLicence: ({ commit }, code) => {
      commit("SET_LOADING", true);
      call("get", licenseConstants.LICENSE_CERTIFICATE(code))
        .then((res) => {
          if (
            res &&
            res.data &&
            res.data.data &&
            Array.isArray(res.data.data) &&
            res.data.data.length
          ) {
            commit("MUTATE", {
              state: "LicenseCertificate",
              data: res.data.data.pop(),
            });
          }
          commit("SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: error.response.data.message,
          });
        });
    },

    getProforma: ({ commit }, no) => {
      commit("SET_LOADING", true);
      call("get", licenseConstants.PROFORMA(no))
        .then((res) => {
          commit("MUTATE", { state: "proforma", data: res.data.data[0] });
          commit("SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: error.response.data.message,
          });
        });
    },

    getMemberInformation({ commit }, payload) {
      commit("SET_LOADING", true);
      call("get", licenseConstants.MEMBER_INFORMATION(payload))
        .then((res) => {
          commit("MUTATE", {
            state: "memberInformation",
            data: res.data.data[0],
          });
          commit("SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: error.response.data.message,
          });
        });
    },

    async getMembershipComments(_context, payload) {
      return await call("get", licenseConstants.MEMBERSHIP_COMMENTS(payload));
    },
  },
};
